import React, { useState, useEffect } from "react";
import { bool, array, object, func } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import CrossIcon from "../../atoms/icons/cross-icon";
import translate from "../../translate";

import "./breaking-news.m.css";

const BreakingNewsView = ({ breakingNewsLoaded, breakingNews, config, navigateToPage }) => {
  const publisherName = get(config, ["publisher-attributes", "name"]);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setIsOpen(true);
    }, 5000);
  }, []);

  const onCloseClick = () => setIsOpen(false);

  const handleClick = () => {
    onCloseClick();
    navigateToPage(`/${linkedStorySlug}`);
  };

  if (breakingNewsLoaded && breakingNews.length === 0) {
    return <span />;
  }

  if (!breakingNews.length) {
    return <span />;
  }

  const [firstItem] = breakingNews;
  const linkedStorySlug = get(firstItem, ["metadata", "linked-story-slug"], null);

  const getHeadlineView = (item) => <div styleName="message">{item.headline}</div>;

  return (
    <div styleName={`wrapper ${isOpen ? "" : "close-wrapper"}`}>
      <span styleName="title">{translate(publisherName, "breaking_news")}</span>
      {linkedStorySlug ? (
        <div styleName="news-link" onClick={handleClick}>
          {getHeadlineView(firstItem)}
        </div>
      ) : (
        getHeadlineView(firstItem)
      )}

      <div styleName="cross-icon" onClick={onCloseClick}>
        <CrossIcon width={22} height={22} />
      </div>
    </div>
  );
};

BreakingNewsView.propTypes = {
  breakingNewsLoaded: bool,
  breakingNews: array,
  config: object,
  navigateToPage: func,
};

const mapDispatchToProps = (dispatch) => ({
  navigateToPage: (url) => global.app.navigateToPage(dispatch, url),
});

export default connect(null, mapDispatchToProps)(BreakingNewsView);
